export default "__VITE_ASSET__BFSLL_Q___"